(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valeria-look-dawn"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aurella-look-dawn')){
customElements.define('aurella-look-dawn',class extends HTMLElement{
connectedCallback(){
this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
this.querySelectorAll('.aml__item').forEach(row=>{
const dialog=row.querySelector('dialog'),fields=[...row.querySelectorAll('[data-aml-option]')],variants=JSON.parse(row.dataset.variants),confirm=row.querySelector('[data-aml-confirm]');
const getVariant=()=>variants.find(v=>fields.every((field,i)=>field.value&&v.options[i]===field.value));
const sheetImage=row.querySelector('[data-aml-sheet-image]');
const originalImage=sheetImage?.getAttribute('src');
const colorIndex=fields.findIndex(field=>/colou?r|colore|couleur|farbe/i.test(field.closest('.aml__field')?.querySelector('label')?.textContent||''));
const previewImage=(variant)=>{
const partial=variants.filter(v=>fields.every((field,i)=>!field.value||v.options[i]===field.value));
const colorValue=colorIndex>=0?fields[colorIndex].value:'';
const sameColor=colorValue?variants.filter(v=>v.options[colorIndex]===colorValue):[];
return variant?.image||partial.find(v=>v.image)?.image||sameColor.find(v=>v.image)?.image||originalImage;
};
const update=()=>{
const variant=fields.length?getVariant():variants[0];
row._variant=variant;
confirm.disabled=!variant?.available;
row.querySelector('[data-aml-sheet-price]').textContent=variant?.priceText||row.dataset.initialPrice;
const nextImage=previewImage(variant);
if(sheetImage&&nextImage){sheetImage.removeAttribute('srcset');sheetImage.src=nextImage;}
};
update();
const open=()=>{if(!dialog.open)dialog.showModal();};
row.querySelector('[data-aml-open]').addEventListener('click',open,{signal});
row.querySelector('[data-aml-close]').addEventListener('click',()=>dialog.close(),{signal});
dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();},{signal});
fields.forEach(field=>field.addEventListener('change',update,{signal}));
const status=(message,success=false)=>{for(const box of row.querySelectorAll('[data-aml-status]')){box.textContent=message;if(success){const link=document.createElement('a');link.href=row.dataset.cart;link.textContent=row.dataset.cartLabel;box.append(link);}}};
const add=async()=>{
const variant=row._variant;if(!variant?.available){open();return;}if(row._busy)return;
row._busy=true;const plus=row.querySelector('[data-aml-plus]');plus.disabled=true;confirm.disabled=true;confirm.setAttribute('aria-busy','true');status('');
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
const data=await response.json();if(!response.ok)throw new Error(data.description||row.dataset.error);
status(row.dataset.added,true);dialog.close();
try{const res=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});if(res.ok){const cart=await res.json();document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart},bubbles:true}));}}catch(error){}
}catch(error){status(error.message||row.dataset.error);}finally{row._busy=false;plus.disabled=false;confirm.removeAttribute('aria-busy');update();}
};
row.querySelector('[data-aml-plus]').addEventListener('click',add,{signal});confirm.addEventListener('click',add,{signal});
});
}
disconnectedCallback(){this.controller?.abort();this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());}
});}

  } catch(e) { console.error(e); }
})();
})();
